import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { toCbListedUser } from './get-users';

/**
 * One user as cb returned it, from three reads: `GET /client/:cid/user/:id` (profile, permissions, reports),
 * `GET /client/:cid/user/:id/region-data` (the hubs and regions the user can see, with names) and the user list
 * (`user_ref`, the reports feature's `permissions_id`).
 */
export const getUser = async (user_id: string): Promise<any> => {
  const [session, regionData, users] = await Promise.all([
    lpRequest('GET', clientPath(`/user/${user_id}`)),
    lpRequest('GET', clientPath(`/user/${user_id}/region-data`)),
    lpRequest('GET', clientPath('/users'))
  ]);
  const listed = toCbListedUser((users || []).find((user: any) => user.id === user_id) || {});

  return {
    ...listed,
    ...session.user,
    id: user_id,
    permissions: {
      ...listed.permissions,
      ...session.permissions,
      reports: session.permissions?.reports || [],
      dos: {
        hubs: (regionData.hubs || []).map(({ id, name }: any) => ({ id, name })),
        regions: (regionData.regions || []).map(({ id, name }: any) => ({ id, name }))
      }
    }
  };
};
